<mat-dialog-content class="mat-typography dialog-content">
    <div *ngIf="buscando">
        <div class="dialog-container">
            <div>
                <h4 class="dialog-title">Búsqueda de Usuario</h4>
            </div>

            <form [formGroup]="userform" class="form-container">
                <mat-form-field appearance="outline" class="input-form">
                    <input matInput name="busc_rut" id="busc_rut" type="text" formControlName="busc_rut"
                        placeholder="RUT" />
                    <mat-error *ngIf="userform.controls?.busc_rut.hasError('invalidRut')">
                        Este rut es <strong>invalido</strong>
                    </mat-error>
                </mat-form-field>
                <button mat-raised-button color="primary" class="submit-button" type="button" (click)="buscarUsuario()"
                    [disabled]="!userform.valid">
                    Buscar <span class="glyphicon glyphicon-user" aria-hidden="true"></span>
                </button>
            </form>
        </div>
    </div>
    <div *ngIf="!buscando">
        <div class="dialog-container">
            <div>
                <h4 class="dialog-title" *ngIf="registro">Registro de Usuario</h4>
                <h4 class="dialog-title" *ngIf="!registro">Actualización de Usuario</h4>
            </div>

            <form [formGroup]="form">
                <div class="centered-content">
                    <div>
                        <div class="form-horizontal">
                            <h4 class="form-signin-heading" *ngIf="registro && identityData">
                                Hola! {{identityData.nombres}} {{identityData.apellidoP}}, por única vez necesitamos que te registres en nuestra Plataforma,
                                para que en un futuro puedas ingresar de manera más expedita.</h4>
                            <h4 class="form-signin-heading" *ngIf="registro && !identityData">
                                Su usuario no existe en el sistema de smartDom, para continuar deberá
                                registrarse en el siguiente formulario</h4>
                            <h4 class="form-signin-heading" *ngIf="!registro">Faltan datos importantes de contacto, por
                                favor, complételos antes de continuar</h4>
                            <br />

                            <div class="form-group">
                                <label for="rut" class="col-md-3 control-label mt5">RUT</label>
                                <div class="col-md-5">
                                    <input name="rut" id="rut" formControlName="rut" formatRut class="form-control mt5"
                                        placeholder="Rut" disabled>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="nombres" class="col-md-3 control-label mt5">Nombres(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5">
                                    <input name="nombres" id="nombres" type="text" formControlName="nombres"
                                        class="form-control mt5" placeholder="Nombres">
                                </div>

                                <div class="alert alert-danger"
                                    *ngIf="btnclicked && form.controls['nombres'].invalid || form.controls['nombres'].invalid && (form.controls['nombres'].dirty || form.controls['nombres'].touched)">
                                    <div *ngIf="form.controls['nombres'].hasError('required')">
                                        Campo Requerido.
                                    </div>
                                    <div *ngIf="form.controls['nombres'].hasError('minlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="apaterno" class="col-md-3 control-label mt5">Apellido Paterno(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5">
                                    <input type="text" class="form-control mt5" name="apaterno" id="apaterno"
                                        formControlName="apellidoP" placeholder="Apellido Paterno">
                                </div>
                                <div class="alert alert-danger"
                                    *ngIf="btnclicked && form.controls['apellidoP'].invalid || form.controls['apellidoP'].invalid && (form.controls['apellidoP'].dirty || form.controls['apellidoP'].touched)">
                                    <div *ngIf="form.controls['apellidoP'].hasError('required')">
                                        Campo Requerido.
                                    </div>
                                    <div *ngIf="form.controls['apellidoP'].hasError('minlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="amaterno" class="col-md-3 control-label mt5">Apellido Materno(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5">
                                    <input type="text" class="form-control mt5" name="amaterno" id="amaterno"
                                        formControlName="apellidoM" placeholder="Apellido Materno">
                                </div>
                                <div class="alert alert-danger"
                                    *ngIf="btnclicked && form.controls['apellidoM'].invalid || form.controls['apellidoM'].invalid && (form.controls['apellidoM'].dirty || form.controls['apellidoM'].touched)">
                                    <div *ngIf="form.controls['apellidoM'].hasError('required')">
                                        Campo Requerido.
                                    </div>
                                    <div *ngIf="form.controls['apellidoM'].hasError('minlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="profesion" class="col-md-3 control-label mt5">Profesión</label>
                                <div class="col-md-5">
                                    <input type="text" class="form-control mt5" name="profesion" id="profesion"
                                        formControlName="profesion" placeholder="Profesón (opcional)">
                                </div>
                            </div>


                            <div class="form-group">
                                <label for="dir_calle" class="col-md-3 control-label mt5">Direcci&oacute;n: Calle(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5">
                                    <input type="text" class="form-control mt5" name="dir_calle" id="dir_calle"
                                        formControlName="calle" placeholder="Calle">
                                </div>
                                <div class="alert alert-danger"
                                    *ngIf="btnclicked && form.controls['calle'].invalid || form.controls['calle'].invalid && (form.controls['calle'].dirty || form.controls['calle'].touched)">
                                    <div *ngIf="form.controls['calle'].hasError('required')">
                                        Campo Requerido.
                                    </div>
                                    <div *ngIf="form.controls['calle'].hasError('minlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="dir_num" class="col-md-3 control-label mt5">Direcci&oacute;n: Numero(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5">


                                    <input type="text" class="form-control mt5" name="dir_num" maxlength="50"
                                        formControlName="numero" id="dir_num" placeholder="Número" inputmode=”numeric”
                                        pattern="[0-9]*">



                                </div>
                                <div class="alert alert-danger"
                                    *ngIf="btnclicked && form.controls['numero'].invalid || form.controls['numero'].invalid && (form.controls['numero'].dirty || form.controls['numero'].touched)">
                                    <div *ngIf="form.controls['numero'].hasError('required')">
                                        Campo Requerido.
                                    </div>
                                    <div *ngIf="form.controls['numero'].hasError('minlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                    <div *ngIf="form.controls['numero'].hasError('pattern')">
                                        Solo se permiten caracteres <strong>numéricos</strong>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="dir_compl" class="col-md-3 control-label mt5">Direcci&oacute;n:
                                    Complemento</label>
                                <div class="col-md-5">
                                    <input type="text" class="form-control mt5" name="dir_compl" id="dir_compl"
                                        formControlName="complemento"
                                        placeholder="Complemento (Ej: Depto 123, Of. 123)">
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="comuna" class="col-md-3 control-label mt5">Región(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5">
                                    <select class="form-control mt5" name="region" id="region" formControlName="region"
                                        (change)="cambiarComunas($event)">

                                        <option *ngFor="let region of regiones?.data; let i = index;"
                                            [value]="region.fieldData.region">
                                            {{region.fieldData.region}}
                                        </option>
                                    </select>
                                    <div class="alert alert-danger"
                                        *ngIf="btnclicked && form.controls['region'].invalid || form.controls['region'].invalid && (form.controls['region'].dirty || form.controls['region'].touched) ">
                                        <div *ngIf="form.controls['region'].hasError('required')">
                                            Campo Requerido.
                                        </div>
                                        <div *ngIf="form.controls['region'].hasError('minlength')">
                                            Ingresaste un valor demasiado corto.
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="form-group">
                                <label for="comuna" class="col-md-3 control-label mt5">Comuna(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5">
                                    <select class="form-control mt5" name="comuna" id="comuna"
                                        [disabled]="comunasFinal?.length == 0" formControlName="comuna">
                                        <option>Seleccionar</option>
                                        <option *ngFor="let comuna of comunasFinal; let i = index;">
                                            {{comuna.fieldData.COM_Nombre}}</option>
                                    </select>


                                </div>
                                <div class="alert alert-danger"
                                    *ngIf="btnclicked && form.controls['comuna'].invalid || form.controls['comuna'].invalid && (form.controls['comuna'].dirty || form.controls['comuna'].touched) ">
                                    <div *ngIf="form.controls['comuna'].hasError('required')">
                                        Campo Requerido.
                                    </div>
                                    <div *ngIf="form.controls['comuna'].hasError('minlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="email" class="col-md-3 control-label mt5">Email(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5">
                                    <input type="email" class="form-control mt5" name="email" id="email"
                                        formControlName="email" placeholder="Email" size="100">
                                </div>
                                <div class="alert alert-danger"
                                    *ngIf="btnclicked && form.controls['email'].invalid || form.controls['email'].invalid && (form.controls['email'].dirty || form.controls['email'].touched)">
                                    <div *ngIf="form.controls['email'].hasError('required')">
                                        Campo Requerido.
                                    </div>
                                    <div *ngIf="form.controls['email'].hasError('minlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                    <div *ngIf="form.controls['email'].hasError('email')">
                                        Debes ingresar un email válido.
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="telefono" class="col-md-3 control-label mt5">Tel&eacute;fono(<span
                                        style="color:red;">*</span>)</label>
                                <div class="col-md-5 mt5">

                                    <div class="input-group prefix">
                                        <span class="input-group-addon">+56</span>
                                        <input type="text" class="form-control" name="telefono" id="telefono"
                                            formControlName="telefono" inputmode=”numeric” pattern="[0-9]*"
                                            placeholder="Tel&eacute;fono" maxlength="9">
                                    </div>
                                </div>
                                <div class="alert alert-danger"
                                    *ngIf="btnclicked && form.controls['telefono'].invalid || form.controls['telefono'].invalid && (form.controls['telefono'].dirty || form.controls['telefono'].touched)">
                                    <div *ngIf="form.controls['telefono'].hasError('required')">
                                        Campo Requerido.
                                    </div>
                                    <div *ngIf="form.controls['telefono'].hasError('minlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                    <div *ngIf="form.controls['telefono'].hasError('maxlength')">
                                        Ingresaste un valor demasiado corto.
                                    </div>
                                    <div *ngIf="form.controls['telefono'].hasError('pattern')">
                                        Solo se permiten caracteres <strong>numéricos</strong>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="registro">


                                <div class="form-group">
                                    <label for="pass1" class="col-md-3 control-label mt5">Contrase&ntilde;a(<span
                                            style="color:red;">*</span>)</label>
                                    <div class="col-md-5" formGroupName="passwords">
                                        <input type="password" class="form-control mt5" name="pass1" id="pass1"
                                            formControlName="password" placeholder="Contrase&ntilde;a" size="40">
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="pass2" class="col-md-3 control-label mt5">Repita contrase&ntilde;a(<span
                                            style="color:red;">*</span>)</label>
                                    <div class="col-md-5" formGroupName="passwords">
                                        <input type="password" class="form-control mt5" name="pass2" id="pass2"
                                            formControlName="repassword" placeholder="Contrase&ntilde;a">
                                    </div>
                                    <div class="alert alert-danger"
                                        *ngIf="btnclicked && (form.controls.passwords.errors?.mismatchedPasswords || form.controls.passwords.value.repassword.length<4||form.controls.passwords.value.password.length<4) || (form.controls.passwords.value.repassword.length<4||form.controls.passwords.value.password.length<4) && (form.controls.passwords.dirty || form.controls.passwords.touched)">
                                        <div *ngIf="form.controls.passwords.errors?.mismatchedPasswords">
                                            Las contraseñas deben coincidir.
                                        </div>
                                        <div
                                            *ngIf="form.controls.passwords.value.repassword.length<4||form.controls.passwords.value.password.length<4">
                                            Ingresaste un valor demasiado corto.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="btn-group">
                        <div class="col-md-2">
                            <button type="button" class="btn btn-primary" (click)="logout(); ">
                                <span class="glyphicon glyphicon glyphicon-arrow-left" aria-hidden="true"> </span>
                                Cancelar
                            </button>
                        </div>
                        <div class="col-md-2"></div>
                        <div class="col-md-2">
                            <button type="button" class="btn btn-primary" (click)="register(); " *ngIf="registro">
                                <span class="glyphicon glyphicon-user" aria-hidden="true"> </span>
                                Registrarse
                            </button>
                            <button type="button" class="btn btn-primary" (click)="register(); " *ngIf="!registro">
                                <span class="glyphicon glyphicon-user" aria-hidden="true"> </span>
                                Actualizar
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</mat-dialog-content>